import isEqual from 'lodash/isEqual';
import {List} from 'immutable';

/*
  Groups items into buckets where grouper(a, b) === true
*/
export default function (items, grouper = isEqual) {
  if (!items) {
    return null;
  }
  return items.reduce((grouped, item) => {
    const index = grouped.findIndex(group => group.some(other => grouper(other, item)));
    return index > -1
      ? grouped.set(index, grouped.get(index).push(item))
      : grouped.push(List([item]));
  }, List());
}
